// Recovered compiled webpack factory 41407. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { I: () => o });
  var n = i(40031),
    s = i(15824),
    r = i(12115);
  function o() {
    n.r.current || (0, s.Uu)();
    let [t] = (0, r.useState)(n.O.current);
    return t;
  }
}
